import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { searchJob, toggleSort } from '../../features/filter/filterSlice';
import { fetchJobs } from '../../features/job/jobSlice';
import JobListItem from './JobListItem';

const JobList = () => {
    const dispatch = useDispatch();
    const {jobs, isLoading, isError, error} = useSelector((state) => state.job);
    const {filter, sort, searchKeyword} = useSelector((state) => state.filter);

    useEffect(() => {
        dispatch(fetchJobs());
    },[dispatch]);

    let content = null;

    if(isLoading){
        content = <h1>Loading...</h1>
    }

    if(!isLoading && isError){
        content = <h3>{error}</h3>
    }

    if(!isLoading && !isError && jobs.length === 0){
        content = <h1>No Jobs Found</h1>
    }

    if(!isLoading && !isError && jobs.length > 0){
        content = jobs
        .filter((job) => {
            if(!filter){
                return true;
            }else{
                return job.type === filter;
            }
        })
        .sort((a, b) => {
            if(sort === "asc"){
                return a.salary - b.salary
            }else if(sort === "desc"){
                return b.salary - a.salary;
            }
            return jobs
        })
        .filter((job) => {
            if(searchKeyword){
             return job.title.toLowerCase().includes(searchKeyword.toLowerCase());
            }
            return job
        })
        .map((job) => <JobListItem key={job.id} job={job} />)
    }
    
    return (
        <div className="lg:pl-[14rem]  mt-[5.8125rem]">
            <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
                <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
                    <h1 className="lws-section-title" >All Available Jobs</h1>
                    <div className="flex gap-4">
                        <div className="search-field group flex-1">
                            <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
                            <input type="text" placeholder="Search Job" className="search-input" value={searchKeyword} onChange={(e) => dispatch(searchJob(e.target.value))} id="lws-searchJob" />
                        </div>
                        <select id="lws-sort" name="sort" autocomplete="sort" className="flex-1" value={sort} onChange={(e) => dispatch(toggleSort(e.target.value))}>
                            <option value="">Default</option>
                            <option value="asc">Salary (Low to High)</option>
                            <option value="desc">Salary (High to Low)</option>
                        </select>
                    </div>
                </div>

                <div className="jobs-list">                  
                     {content}
                </div>
            </main>
        </div>
    );
};

export default JobList;